module.exports = __webpack_public_path__ + "img/foresight.c531156.jpg";